/* custom code start */
/*
 * occ-auto-gift
 *
 * Shop metafield'larından beslenen otomatik hediye (GWP) sistemi. Kural
 * verisini occ-auto-gift-data section'ı üretir (ilk yüklemede sayfadaki
 * inline JSON, sonraki kontrollerde Section Rendering API). Kontrol şu
 * anlarda çalışır ve sepeti istenen duruma getirir:
 *
 *   - her sayfa AÇILIŞINDA (sepet sayfası dahil — /cart doğrudan açılsa
 *     bile baremler değerlendirilip hediye eklenir/silinir),
 *   - her cart-update pub/sub olayında (PDP ekleme, drawer/sepet adet
 *     değişimi, app eklemeleri),
 *   - bfcache'ten dönüşte (geri tuşu) ve sekme tekrar görünür olduğunda
 *     (başka sekmede sepet değişmiş olabilir).
 *
 *   - Basit kurgular: eşik (fiyat_baremi) aşıldıysa hediye eklenir,
 *     eşiğin altına inildiyse otomatik silinir.
 *   - Baremli kurgu: yalnızca geçilen EN YÜKSEK bareme ait hediye sepette
 *     tutulur. 5000→X, 7500→Y kurgusunda sepet 7500'ü geçince X silinip Y
 *     eklenir; 5000-7500 aralığına dönülünce Y silinip X eklenir.
 *
 * Hediye satırları `_otomatik_hediye` line item property'si ile işaretlenir
 * (değeri kural id'si). Eşik hesabı (kural başına eligibleTotal) bu
 * satırları dışarıda bırakır, bu yüzden hediyenin kendi fiyatı baremi
 * tetiklemez; kuralda koleksiyon filtresi varsa yalnızca o koleksiyondaki
 * ürünlerin tutarı sayılır (section tarafında hesaplanır). Hediye
 * satırının adedi her zaman 1'e sabitlenir; kuralı kalkan / baremi değişen
 * satırlar silinir.
 */
(function () {
  if (window.__occAutoGiftInit) return;
  window.__occAutoGiftInit = true;

  // Tema editöründe müşteri sepetine dokunma.
  if (window.Shopify && window.Shopify.designMode) return;

  const SOURCE = 'occ-auto-gift';
  const SECTION_ID = 'occ-auto-gift-data';
  const DATA_NODE_ID = 'OccAutoGiftData';
  const PROPERTY_KEY = '_otomatik_hediye';
  const DEBOUNCE_MS = 250;

  let isRunning = false;
  let pendingRerun = false;
  let inlineDataConsumed = false;
  let debounceTimer = null;

  // Eklenmesi reddedilen varyantlar (ör. stok bitti): sayfa ömrü boyunca
  // tekrar denenmez, baremli kurguda otomatik olarak alt bareme düşülür.
  const failedVariantIds = {};

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function parseDataNode(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (_error) {
      return null;
    }
  }

  async function fetchData() {
    const response = await fetch(`${rootUrl()}?section_id=${SECTION_ID}`, {
      headers: { Accept: 'text/html' },
    });
    if (!response.ok) throw new Error(response.statusText);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return parseDataNode(doc.getElementById(DATA_NODE_ID));
  }

  // İstenen durum: kural id → sepette olması gereken varyant id.
  function computeDesired(data) {
    const desired = {};

    (data.rules || []).forEach(function (rule) {
      if (!rule || !rule.collectionOk) return;
      // Kural başına tutar: koleksiyon filtresi varsa yalnızca o
      // koleksiyondaki ürünlerin toplamı.
      const eligibleTotal = Number(rule.eligibleTotal) || 0;

      if (rule.type === 'simple') {
        const gift = rule.gift;
        if (!gift || !gift.available || failedVariantIds[gift.variantId]) return;
        if (eligibleTotal >= rule.threshold) {
          desired[rule.id] = gift.variantId;
        }
        return;
      }

      if (rule.type === 'tiered') {
        // Geçilen en yüksek barem kazanır; eşit baremde listede sonraki
        // ürün kazanır. Stokta olmayan barem atlanır (alt bareme düşülür).
        let winner = null;
        (rule.tiers || []).forEach(function (tier) {
          if (!tier.available || failedVariantIds[tier.variantId]) return;
          if (eligibleTotal < tier.threshold) return;
          if (!winner || tier.threshold >= winner.threshold) {
            winner = tier;
          }
        });
        if (winner) {
          desired[rule.id] = winner.variantId;
        }
      }
    });

    return desired;
  }

  // Mevcut hediye satırları ile istenen durum arasındaki fark:
  // updates → silinecek / adedi 1'e çekilecek satırlar (cart/update.js)
  // adds    → eklenecek hediyeler (cart/add.js)
  function computeOps(data) {
    const desired = computeDesired(data);
    const updates = {};
    const adds = [];
    const keptRules = {};

    (data.giftLines || []).forEach(function (line) {
      const wantedVariantId = desired[line.ruleId];

      if (!wantedVariantId || wantedVariantId !== line.variantId || keptRules[line.ruleId]) {
        // Kuralı kalkmış, baremi değişmiş veya yinelenmiş hediye satırı.
        updates[line.key] = 0;
        return;
      }

      keptRules[line.ruleId] = true;
      if (line.quantity !== 1) {
        updates[line.key] = 1;
      }
    });

    Object.keys(desired).forEach(function (ruleId) {
      if (keptRules[ruleId]) return;
      const properties = {};
      properties[PROPERTY_KEY] = ruleId;
      adds.push({ id: desired[ruleId], quantity: 1, properties: properties });
    });

    return { updates: updates, adds: adds };
  }

  async function postCart(path, payload) {
    const response = await fetch(rootUrl() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json().catch(function () {
      return null;
    });
    if (!response.ok || (result && result.status)) {
      const error = new Error((result && (result.description || result.message)) || `${path} failed`);
      error.result = result || { status: response.status };
      throw error;
    }
    return result;
  }

  async function addGifts(adds) {
    try {
      await postCart('cart/add.js', { items: adds });
      return;
    } catch (_batchError) {
      // Toplu ekleme reddedildi (ör. hediyelerden biri stokta yok):
      // tek tek dene, reddedilen varyantı bir daha deneme.
      for (const add of adds) {
        try {
          await postCart('cart/add.js', { items: [add] });
        } catch (addError) {
          if (addError && addError.result) {
            failedVariantIds[add.id] = true;
            // Kural yeniden değerlendirilsin (ör. baremli kurguda alt
            // bareme düşüş) diye bir tur daha planla.
            pendingRerun = true;
          }
        }
      }
    }
  }

  function getSectionsToRender() {
    const sections = [
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
    }

    const footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    }

    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  function renderSections(sectionsHtml, sections) {
    if (!sectionsHtml) return;

    sections.forEach(function (section) {
      const target = document.getElementById(section.id);
      const sectionHtml = sectionsHtml[section.section];
      if (!target || !sectionHtml) return;

      const elementToReplace = target.querySelector(section.selector) || target;
      elementToReplace.innerHTML = getSectionInnerHTML(sectionHtml, section.selector);
    });

    if (typeof window.enrichDataLayerViewCart === 'function') {
      window.enrichDataLayerViewCart();
    }
  }

  async function fetchCart() {
    const response = await fetch(`${rootUrl()}cart.js`, { headers: { Accept: 'application/json' } });
    return response.json();
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cartData });
    }
  }

  // Sepet mutasyonu sonrası arayüzü tazele: header bubble + (varsa) sepet
  // sayfası section'ları burada, drawer ise publish edilen cart-update'i
  // dinleyen cart-drawer-items tarafından kendi rutiniyle yenilenir.
  async function refreshCartUI() {
    const sections = getSectionsToRender();
    const ids = sections.map(function (section) {
      return section.section;
    });

    try {
      const response = await fetch(`${rootUrl()}?sections=${encodeURIComponent(ids.join(','))}`, {
        headers: { Accept: 'application/json' },
      });
      renderSections(await response.json(), sections);
    } catch (_error) {
      /* görsel tazeleme başarısız olsa da publish drawer'ı toparlar */
    }

    try {
      publishCartUpdate(await fetchCart());
    } catch (_error) {
      publishCartUpdate(null);
    }
  }

  async function run(useInlineData) {
    if (isRunning) {
      pendingRerun = true;
      return;
    }
    isRunning = true;

    try {
      let data = null;
      if (useInlineData && !inlineDataConsumed) {
        data = parseDataNode(document.getElementById(DATA_NODE_ID));
      }
      inlineDataConsumed = true;
      if (!data) data = await fetchData();
      if (!data || !Array.isArray(data.rules)) return;

      const ops = computeOps(data);
      const hasUpdates = Object.keys(ops.updates).length > 0;
      const hasAdds = ops.adds.length > 0;
      if (!hasUpdates && !hasAdds) return;

      // Önce sil / düzelt (barem değişiminde eski hediye kalkar),
      // sonra yeni hediyeyi ekle.
      if (hasUpdates) {
        await postCart('cart/update.js', { updates: ops.updates });
      }
      if (hasAdds) {
        await addGifts(ops.adds);
      }

      await refreshCartUI();
    } catch (_error) {
      /* sessiz geç: bir sonraki cart-update tetiklemesinde tekrar denenir */
    } finally {
      isRunning = false;
      if (pendingRerun) {
        pendingRerun = false;
        schedule();
      }
    }
  }

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      run(false);
    }, DEBOUNCE_MS);
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === SOURCE) return;
        schedule();
      });
    }

    // bfcache'ten dönen sayfada inline veri bayat olabilir; taze kontrol et.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) schedule();
    });

    // Sekme tekrar görünür olduğunda (başka sekmede sepet değişmiş
    // olabilir) baremleri taze veriyle yeniden değerlendir.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) schedule();
    });

    // Sayfa açılışı kontrolü: sepet sayfası dahil her sayfada, sayfayla
    // birlikte render edilen inline veriyle hemen çalışır.
    run(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* custom code end */
